/* Keep early trust-badge activations until Loox's asynchronously loaded API is ready. */
(function () {
  'use strict';
  if (window.__uaLooxBadgeGuard) return;
  window.__uaLooxBadgeGuard = true;

  var pending = null;
  var timer = null;

  function cancel() {
    clearTimeout(timer);
    timer = null;
    pending = null;
  }

  function modalExists() {
    return !!document.getElementById('looxModalFrame');
  }

  function attempt() {
    timer = null;
    if (!pending) return;
    if (!pending.badge.isConnected || modalExists() || Date.now() >= pending.deadline) {
      cancel();
      return;
    }
    var loox = window.LOOX;
    if (loox && typeof loox.openHCFloater === 'function' && loox.root && loox.clientId) {
      // This is the same opener used by the native Loox trust-badge component.
      // Stop before invoking it so closing a successful modal never reopens it.
      cancel();
      loox.openHCFloater();
      return;
    }
    timer = setTimeout(attempt, 100);
  }

  function activate(event) {
    var keyboard = event.type === 'keydown';
    if (keyboard && event.key !== 'Enter' && event.key !== ' ') {
      if (event.key === 'Escape') cancel();
      return;
    }
    if (keyboard && event.repeat) return;
    if (!keyboard && event.button !== 0) return;
    var path = event.composedPath();
    var badge = path.find(function (node) {
      return node.matches && node.matches('loox-trust-badge-widget, .loox-trust-badge-container');
    });
    if (!badge) {
      cancel();
      return;
    }
    // Only the review control is actionable; never hijack links or wrapper whitespace.
    var control = path.find(function (node) {
      return node.matches && node.matches('[role="button"], button');
    });
    if (!control || path.some(function (node) { return node.matches && node.matches('a'); })) return;
    if (badge.getAttribute('open-reviews') === 'false' || badge.getAttribute('data-loox-open-reviews') === 'false') return;
    // Own only this badge activation, avoiding duplicate native keyboard/click handlers.
    event.preventDefault();
    event.stopImmediatePropagation();
    if (modalExists()) return;
    cancel();
    pending = { badge: badge, deadline: Date.now() + 8000 };
    attempt();
  }

  document.addEventListener('click', activate, true);
  document.addEventListener('keydown', activate, true);
  window.addEventListener('pagehide', cancel);
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) cancel();
  });
})();
